import React from "react";
import logo from "../../Assests/Images/logo.png";

const Logo = props => {
  return <img src={logo} alt="Gross Man Young" style={{maxWidth:"250px"}} {...props} />;
};

export default Logo;